import React from "react";
import { useTranslation } from "react-i18next";

import style from "./integrations-view.scss";
import { IntegrationsViewContent } from "./IntegrationsViewContent";
import ApplicationLayout from "components/layout/ApplicationLayout";
import { INTEGRATIONS_ROUTE } from "components/router/Routes";

const IntegrationsView = () => {
    const { t } = useTranslation();

    return (
        <ApplicationLayout
            viewTitle={t("Integrations.title")}
            view={<IntegrationsViewContent />}
            mainRoute={INTEGRATIONS_ROUTE}
            className={style.integrationsView}
        />
    );
};

export default IntegrationsView;
